import React, { FC } from "react";
import { ESRQuestionSubGroup } from "./ESRQuestionSubGroup";
import { ESRQuestionGroupConfig } from "../types/data";
import { Box, Typography } from "@mui/material";

export const ESRQuestionGroup: FC<ESRQuestionGroupConfig> = (props) => {
	return (
		<Box
			sx={{
				w: "100%",
				p: "20px",
			}}
		>
			<Typography component="h2" fontSize={24} fontWeight={700}>
				{props.name}
			</Typography>
			{props.subgroups.map((subgroup, index) => (
				<ESRQuestionSubGroup key={index} {...subgroup} />
			))}
		</Box>
	);
};
